import { Dispatch, useState } from 'react'
import MainPageWrapper from '../../../global/components/MainPageWrapper'
import SchedulePageHeaders from '../schedule-page-headers/SchedulePageHeaders'
import TechTableContainer from '../technician-table/table-container/TechTableContainer'
import { getCurrentDate } from '../../../global/utils/date/dates'

export interface IScheduleFilterProps {
  date: string
  locationObjectId: string
}
export interface IScheduleFilter {
  scheduleFilter: IScheduleFilterProps
  setScheduleFilter: Dispatch<React.SetStateAction<IScheduleFilterProps>>
}
function ScheduleMain() {
  function initialDate() {
    const savedDate = localStorage.getItem('selectedDate')
    return savedDate ? savedDate : getCurrentDate()
  }
  function initialLocation() {
    return localStorage.getItem('selectedLocationObjectId') ?? ''
  }
  const [scheduleFilter, setScheduleFilter] = useState<IScheduleFilterProps>({
    date: initialDate(),
    locationObjectId: initialLocation(),
  })
  return (
    <MainPageWrapper
      titleFields={
        <SchedulePageHeaders
          scheduleFilter={scheduleFilter}
          setScheduleFilter={setScheduleFilter}
        />
      }
      title='Schedule'
      stickyTitle={true}
    >
      <TechTableContainer
        scheduleFilter={scheduleFilter}
        setScheduleFilter={setScheduleFilter}
      />
    </MainPageWrapper>
  )
}

export default ScheduleMain
